import Vue from "vue";
import VueRouter from "vue-router";
// import { isAdmin } from "@/store/state";
Vue.use(VueRouter);

// const requireAuth = () => (to, from, next) => {
//   let accesstoken = localStorage.getItem("accesstoken");
//   if (accesstoken == null || accesstoken == undefined) {
//     alert("로그인 후 사용가능 합니다.");
//     next("/");
//   } else {
//     next();
//   }
//   next();
// };

// const redirect = () => (to, from, next) => {
//   let accesstoken = localStorage.getItem("accesstoken");
//   if (accesstoken) {
//     alert("이미 로그인 하였습니다.");
//     next("/");
//   } else {
//     next();
//   }
// };

// const requireAdmin = () => (to, from, next) => {
//   let accesstoken = localStorage.getItem("accesstoken");
//   if (accesstoken && this.$store.state.isAdmin == true) {
//     next();
//   } else {
//     next("/");
//   }
// };

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/audio/Recording.vue"),
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import("../components/privateLegal.vue"),
  },
  {
    path: "/account/me",
    name: "me",
    component: () => import("../views/account/Profile.vue"),
    meta: {
      title: 'me'
    }
  },
  {
    path: "/account/login",
    name: "login",
    component: () => import("../views/account/Login.vue"),
    meta: {
      title: 'login'
    }
  },
  {
    path: "/audio/recording",
    name: "recording",
    component: () => import("../views/audio/Recording.vue"),
    meta: {
      title: 'recording'
    }
  },
  {
    path: "/audio/noiseCancel",
    name: "noiseCancel",
    component: () => import("../views/audio/NoiseCancel.vue"),
    meta: {
      title: 'noiseCancel'
    }
  },
  {
    path: "/audio/encoding",
    name: "encoding",
    component: () => import("../views/audio/Encoding.vue"),
    meta: {
      title: 'encoding'
    }
  },
  {
    path: "/audio/editor",
    name: "editor",
    component: () => import("../views/audio/AudioEditor.vue"),
    meta: {
      title: 'editor'
    }
  },
  {
    path: "/checkout/charge",
    name: "charge",
    component: () => import("../views/checkout/Charge.vue"),
    meta: {
      title: 'charge'
    }
  },
  {
    path: "/storage",
    name: "storage",
    component: () => import("../views/storage/Index.vue"),
  },
  {
    path: "/checkout/pricing",
    name: "pricing",
    component: () => import("../views/checkout/Pricing.vue"),
    meta: {
      title: 'pricing'
    }
  },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
